import { render } from "./CurrentDate.vue?vue&type=template&id=ad51ebb0&scoped=true&ts=true"
import script from "./CurrentDate.vue?vue&type=script&lang=ts"
export * from "./CurrentDate.vue?vue&type=script&lang=ts"

import "./CurrentDate.vue?vue&type=style&index=0&id=ad51ebb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad51ebb0"]])

export default __exports__